import { ReactComponent as CheckChunkierSvg } from '../../../../assets/icons/CheckChunkier.svg';

import { createIconComponent } from './createIconComponent';

export const CheckChunkierIcon = createIconComponent(CheckChunkierSvg);
